import React from 'react';
import { useDispatch } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import { Formik, FormikHelpers } from 'formik';

import { useIsRequired } from '@hooks/yup';

import InsurancePolicyBuyForm, { FormRequired, FormValues } from '../InsurancePolicyBuyForm';
import { insurancePolicyCreate, InsurancePolicyCreatePayload } from '../action';
import { useInitialValues, useValidationSchema } from './hook';

const InsurancePolicyBuyNewPage = () => {
  const dispatch = useDispatch();
  const initialValues = useInitialValues();
  const validationSchema = useValidationSchema();
  const required = useIsRequired<FormRequired>(validationSchema);

  const handleSubmit = (values: FormValues, { setSubmitting }: FormikHelpers<FormValues>) => {
    const payload: InsurancePolicyCreatePayload = values
    dispatch(insurancePolicyCreate(payload));
    setSubmitting(false);
  };

  return (
    <Container className="my-3">
      <Row className="gy-5">
        <Col lg={8}>
          <Formik validationSchema={validationSchema} initialValues={initialValues} onSubmit={handleSubmit}>
            <InsurancePolicyBuyForm required={required} />
          </Formik>
        </Col>
      </Row>
    </Container>
  );
};

export { InsurancePolicyBuyNewPage };
